import { ReactNode } from 'react';

import { BrandL, BrandM } from '@sorare/core/src/atoms/typography';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

export const ResponsiveTitle = ({ children }: { children: ReactNode }) => {
  const isTabletAndAbove = useIsTabletAndAbove();
  if (isTabletAndAbove) {
    return (
      <BrandL className="text-center" bold>
        {children}
      </BrandL>
    );
  }
  return (
    <BrandM className="text-center" bold>
      {children}
    </BrandM>
  );
};
